import { TourConfig, startTour, CONTINUE_PLATFORM_TOUR_BUTTON } from './TourSystem';
import PageWelcomeModal from './PageWelcomeModal';
import 'driver.js/dist/driver.css';

const talentTourConfig: TourConfig = {
    tourId: 'talent',
    steps: [
        {
            element: '#talent-search',
            popover: {
                title: '🔍 Search Experts',
                description: 'Looking for specific skills? Use this powerful search bar to find developers, designers, and consultants by name, role, or keyword.',
                side: "bottom",
            }
        },
        {
            element: '#talent-filters',
            popover: {
                title: '🎯 Filter by Role',
                description: 'Narrow down your search. Click any category to see only experts in that field, from Healthcare to Engineering.',
                side: "bottom",
            }
        },
        {
            element: '#talent-grid',
            popover: {
                title: '👥 Talent Pool',
                description: 'Browse our community of verified experts. Each card shows their rating, top skills, and availability status.',
                side: "top",
            }
        },
        {
            element: '#talent-grid > div:first-child',
            popover: {
                title: '👤 Professional Profile',
                description: 'Click any card to view their full profile, portfolio, and work history. You can hire or message them directly from there.',
                side: "right",
            }
        },
        {
            popover: {
                title: '🚀 Build Your Team',
                description: `Find the perfect match for your project needs. Start connecting today!${CONTINUE_PLATFORM_TOUR_BUTTON}`,
            }
        }
    ],
};

export const startTalentTour = () => {
    startTour(talentTourConfig);
};

const TalentTour = () => {
    return (
        <PageWelcomeModal
            title="Welcome to Talent Network"
            description="Connect with world-class experts and build your dream team."
            onStartTour={startTalentTour}
            tourId="talent"
        />
    );
};

export default TalentTour;
